<template>
  <div class="md-layout md-gutter md-alignment-top-center">
    <TextField label="作業者No" type="number" v-model="maintenanceHandyUserId" @keyup="keyup" @click="signIn" />
  </div>
</template>

<script>
  import TextField from '@/components/parts/TextField';

  export default {
    name: 'SelectBox',
    created() {
      this.$parent.title = 'ログイン';
      this.$parent.imageName = '';
      this.$parent.showMaintenanceInformation = false;
      this.$parent.hasMaintenancne = false;
      this.$store.dispatch('clearStore');
    },
    data() {
      return {
        maintenanceHandyUserId: '',
      };
    },
    components: {
      TextField,
    },
    methods: {
      signIn() {
        this.$store.dispatch('signIn', { maintenanceHandyUserId: this.maintenanceHandyUserId })
          .then(() => { this.$router.push({ name: 'SelectBox' }); })
          .catch((e) => { alert(e.data.error.message); });
      },
      keyup(e) {
        if (this.maintenanceHandyUserId !== '' && e.keyCode === 13) {
          this.signIn();
        }
      },
    },
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/SignIn.vue?1df2c686